import { Layout, Row, Spin, Table, Icon, Button } from "antd";

import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import FilterForm from "./form";
import getColumn from "./column";
import jwtDecode from "jwt-decode";
import services from "./services";
import DataInputModal from "./modals/filledModal";
import { Constant } from "../../config";

const { Content } = Layout;

class BlackListPage extends Component {
  state = {
    loading: false,
    dataSource: [],
    adminList: [],
    defaultSearch: null,
    showInputModal: false,
    currentData: {},
  };

  currentPage = 1;
  currentSearch = "";
  limit = 10;
  totalRows = 0;

  componentWillMount() {
    this.props.fetchMenuAction("blacklist", "");
    this.setState({ loading: true });
  }

  async componentDidMount() {
    const adminList = await services.getAdminLists();

    const defaultSearch = { member_id: -1 };
    this.currentSearch = JSON.stringify(defaultSearch);
    const { totalRows, dataSource } = await services.getBlackList(
      this.currentPage,
      this.limit,
      this.currentSearch
    );

    this.totalRows = totalRows;

    this.setState({
      loading: false,
      dataSource,
      adminList: adminList.list,
      defaultSearch,
    });
  }

  changePage = async (page, limit) => {
    this.setState({ loading: true });
    this.currentPage = page;
    this.limit = limit;

    const { dataSource, totalRows } = await services.getBlackList(
      page,
      limit,
      this.currentSearch
    );

    if (totalRows > 0 && dataSource.length === 0) {
      this.changePage(1, this.limit);
      this.setState({ loading: false });
    }

    this.totalRows = totalRows;
    this.setState({
      dataSource,
      loading: false,
    });
  };

  toggleStatus = async (value, record) => {
    const d = jwtDecode(localStorage.getItem(Constant.SessionKey));
    const convStatus = {
      true: "enabled",
      false: "disabled",
      delete: "deleted",
    };
    const preparedValue = {
      ...record,
      status: convStatus[value],
      updated_by: d["id"],
    };

    delete preparedValue.created_by;

    const resp = await services.updateBlackList(preparedValue);
    const result = services.handlerError(resp);
    if (!result) {
      return;
    }
    this.changePage(this.currentPage, this.limit);
  };

  handlerEdit = (record) => {
    this.setState({
      showInputModal: true,
      currentData: record,
    });
  };

  afterFormSubmit = (value) => {
    let tmp;
    if (value) {
      tmp = JSON.parse(value);
      tmp = { ...this.state.defaultSearch, ...tmp };

      if (tmp["created_by"]) {
        tmp["created_by"] = `${tmp["created_by"]}`;
      }
    } else {
      tmp = this.state.defaultSearch;
    }
    //add memberid = 1;

    this.currentSearch = JSON.stringify(tmp);
    this.changePage(this.currentPage, this.limit);
  };

  handleOnClickAdding = () => {
    this.setState({
      showInputModal: true,
    });
  };

  handleOnCloseModalInput = async (_, succeed) => {
    if (succeed) {
      await this.changePage(this.currentPage, this.limit);
    }

    this.setState({
      showInputModal: false,
      currentData: {},
    });
  };

  render() {
    const propsTable = {
      className: "my-table",
      columns: getColumn(this.toggleStatus, this.handlerEdit),
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.limit,
        total: this.totalRows,
        current: this.currentPage,
        onChange: this.changePage,
        size: "small",
      },
    };

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <FilterForm
            adminList={this.state.adminList}
            onSubmit={(v) => this.afterFormSubmit(v)}
          />
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: "16px 0",
              minHeight: 300,
            }}
          >
            <Row className="utility-bar-mobile"></Row>
            <div style={{ textAlign: "end" }}>
              <Button onClick={this.handleOnClickAdding}>
                <Icon type="plus-circle" /> เพิ่มรายการ
              </Button>
            </div>

            <Table style={{ marginTop: "8px" }} {...propsTable} />
          </Content>
          {this.state.showInputModal && (
            <DataInputModal
              data={this.state.currentData}
              onClose={this.handleOnCloseModalInput}
              visible={this.state.showInputModal}
            />
          )}
        </Spin>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headerBarStore: state.headerBar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BlackListPage);



// WEBPACK FOOTER //
// ./src/containers/BlackList/index.js